export default __webpack_public_path__ + "static/media/workout.2455dd03.png";